import "maptalks/dist/maptalks.css";
import * as maptalks from "maptalks";
import store from "@/store/modules/map.js";
let vm = null;
TalksMap.prototype.sendThis = function (_this) {
  vm = _this;
};
function TalksMap(mapid) {
  this.map = "";
  if (this.i > 0) {
    clearInterval(this._timer);
  }
  this.i = 0;
  this.lineLog = []; //回放路线
  this.speed = 600; //轨迹回放速度
  this.fist = true;
  this.btnName = "";
  this.lastLinePoints = [];
  this.markerLngLat = "";
  this.lastLine = "";
  this.url =
    "http://t0.tianditu.gov.cn/img_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    "&tk=de76277643ead14d15ecb9dc1e9f713e";
  this.wordUrl =
    "http://t0.tianditu.gov.cn/cia_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    "&tk=de76277643ead14d15ecb9dc1e9f713e";
  this.baseLayer = new maptalks.TileLayer("base", {
    urlTemplate: this.url,
    subdomains: ["1", "2", "3", "4"],
    attribution:
      '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>',
  });
  this.layer = [
    new maptalks.TileLayer("boudaries", {
      urlTemplate: this.wordUrl,
      subdomains: ["1", "2", "3", "4"],
    }),
  ];
}
TalksMap.prototype.init = function (
  container,
  zoom = 16,
  center = [116.177427669, 28.861500052]
) {
  this.map = new maptalks.Map(container, {
    center,
    crossOrigin: "Anonymous",
    zoom,
    // maxZoom: 18,
    spatialReference: false,
    //			pitch: 56,
    //			bearing: 30,
    baseLayer: this.baseLayer,
    layers: this.layer,
  });
  this.allLineLayer = new maptalks.VectorLayer("lineVector", {
    enableAltitude: false,
  }).addTo(this.map);

  this.lastLineLayer = new maptalks.VectorLayer("greenLine").addTo(this.map);
  this.carPoint = new maptalks.VectorLayer("carPoint").addTo(this.map);
  this.allLayer = new maptalks.VectorLayer("vector").addTo(this.map);
  this.landLayer = new maptalks.VectorLayer("landArr").addTo(this.map);
  this.markerLayer = new maptalks.VectorLayer("marker").addTo(this.map);

  this.polygonLayerLand = new maptalks.VectorLayer("polygonLand").addTo(
    this.map
  );
  this.picMarker = new maptalks.VectorLayer("picMarker").addTo(this.map);
};
//	添加轨迹
TalksMap.prototype.drawLine = function (lineArr) {
  this.allLineLayer.clear();
  this.lastLineLayer.clear();
  var line = new maptalks.LineString(lineArr, {
    arrowStyle: null, // arrow-style : now we only have classic
    arrowPlacement: "vertex-last", // arrow's placement: vertex-first, vertex-last, vertex-firstlast, point
    visible: true,
    editable: true,
    properties: {
      altitude: [400], //seperate altitude for each vertex
    },
    cursor: null,
    shadowBlur: 0,
    shadowColor: "black",
    draggable: false,
    dragShadow: false, // display a shadow during dragging
    drawOnAxis: null, // force dragging stick on a axis, can be: x, y
    symbol: {
      lineColor: "#f00",
      lineWidth: 2,
      smoothness: 0.5,
    },
  });
  line.addTo(this.allLineLayer);
  this.map.setZoom(16);
};
//	点击轨迹操作按钮
TalksMap.prototype.playBack = function (
  pointArray,
  operationName,
  markerLastRunPosition,
  stopFlag,
  workName,
  speedNum
) {
  this.workName = workName;
  if (operationName === "start") {
    this.lineLog = pointArray;
    let markerPosition =
      markerLastRunPosition && markerLastRunPosition > 0
        ? markerLastRunPosition
        : 0;
    if (this.fist) {
      var points = [];
      if (markerPosition === this.i && stopFlag) {
        this.carPoint.clear();
        var imgUrl = null;
        if (workName && workName == "无人机植保") {
          imgUrl = require("@/assets/icon_car.png");
        } else {
          imgUrl = require("@/assets/icon_car.png");
        }
        var point = new maptalks.Marker(
          [this.lineLog[markerPosition][0], this.lineLog[markerPosition][1]],
          {
            symbol: [
              {
                markerFile: imgUrl,
                markerWidth: 20,
                markerHeight: 25,
                markerDx: 0,
                markerDy: 0,
                markerOpacity: 1,
              },
            ],
          }
        );
        point.addTo(this.carPoint);
      }
    }
  }
  if (operationName == "start") {
    //开始
    clearInterval(this._timer);
    this.lastLinePoints = [];
    this.btnName = "";
    this.i = 0;
    this.fist = false;
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum);
  } else if (operationName == "accelerate") {
    // 加速
    this.fist = false;
    clearInterval(this._timer);
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum);
  } else if (operationName == "slowdown") {
    //减速
    this.fist = false;
    clearInterval(this._timer);
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum);
  } else if (operationName == "stop") {
    //停止
    this.fist = true;
    this.lineLog = [];
    this.i = 0;
    clearInterval(this._timer);
  } else if (operationName == "pause") {
    //暂停
    this.fist = false;
    this.i = markerLastRunPosition;
    clearInterval(this._timer);
  } else if (operationName == "continue") {
    //继续
    this.fist = false;
    this.i = markerLastRunPosition;
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum);
  }
};
TalksMap.prototype.onlyAddmarker = function (i) {
  var icon = null;
  if (this.workName && this.workName == "无人机植保") {
    icon = require("@/assets/icon_car.png");
  } else {
    icon = require("@/assets/icon_car.png");
  }

  let markPosition = this.i > 0 ? this.i - 1 : 0;
  let currentLngLat;
  if (this.lineLog.length > 0) {
    this.allLayer.clear();
    let extent = this.map.getExtent();
    let extentArr = [
      [extent.xmin, extent.ymin],
      [extent.xmax, extent.ymin],
      [extent.xmax, extent.ymax],
      [extent.xmin, extent.ymax],
    ];

    if (this.carPoint.getCount()) {
      this.carPoint.clear();
    }
    let multiPolygon = new maptalks.Polygon(extentArr, {
      visible: true,
      symbol: {
        lineColor: "#c4c710",
        lineWidth: 0,
        polygonFill: "#c4c710",
        polygonOpacity: 0,
      },
    });
    if (markPosition <= this.lineLog.length) {
      if (markPosition === this.lineLog.length) {
        // eslint-disable-next-line no-const-assign
        markPosition = this.lineLog.length - 1;
      }

      multiPolygon.addTo(this.allLayer);
      currentLngLat = [
        this.lineLog[markPosition][0],
        this.lineLog[markPosition][1],
      ];
      let inExtent = multiPolygon.containsPoint(
        new maptalks.Coordinate(currentLngLat)
      );
      if (!inExtent) {
        this.map.setCenter(currentLngLat);
      }

      this.markerLngLat = [this.lineLog[0][0], this.lineLog[0][1]];
      //	设置角度偏转以及行驶过的路线变为绿色
      if (markPosition > 0) {
        let lastLngLat = [
          this.lineLog[markPosition - 1][0],
          this.lineLog[markPosition - 1][1],
        ];
        this.angle = getAngle(lastLngLat, currentLngLat);
        this.lastLinePoints.push([
          Number(this.lineLog[markPosition - 1][0]),
          Number(this.lineLog[markPosition - 1][1]),
        ]);
      }
      if (this.lastLineLayer.getCount() > 0) {
        this.lastLineLayer.clear();
      }
      this.lastLine = new maptalks.LineString(this.lastLinePoints, {
        symbol: {
          lineColor: "yellow",
          lineWidth: 2,
          smoothness: 0.5,
        },
      });
      this.lastLine.addTo(this.lastLineLayer);

      var point = new maptalks.Marker(currentLngLat, {
        symbol: [
          {
            markerFile: icon,
            markerWidth: 20,
            markerHeight: 25,
          },
        ],
      });
      point.addTo(this.carPoint);
      point.updateSymbol({
        markerRotation: 360 - this.angle || 0,
      });

      if (this.i >= this.lineLog.length) {
        clearInterval(this._timer);
        this.lineLog = [];
        this.i = 0;
        this.btnName = "开始";
        vm.$store.state.map.kName = "";
        vm.$store.state.map.kName = "start";
        if (document.getElementById("pauseBtnsText") !== null) {
          document.getElementById("pauseBtnsText").innerHTML = "开始";
          document.getElementById(
            "starImgs"
          ).src = require("@/assets/start.png");
        }
        if (document.getElementById("pauseBtns") !== null) {
          document.getElementById("pauseBtns").innerHTML = "开始";
          document.getElementById(
            "starImg"
          ).src = require("@/assets/start.png");
        }
        if (vm.$refs.trackLayer) {
          vm.$refs.trackLayer.$store.state.map.kName = "";
          vm.$refs.trackLayer.$store.state.map.kName = "end";
        }

        this.fist = true;
        this.lastLinePoints = [];
        this.lastLineLayer.clear();
        point.setCoordinates(this.markerLngLat);
        // this.i = 0
      } else {
        this.i++;
        //		lineDatas.push(currentLngLat);
      }
    }
  }
};
/**
 * @descripttion: 绘制地块
 * @Author: juanjuanhui
 * @Date: 2022-01-03 11:40:59
 * @param {*} data 数据
 * @param {*} dataName 数据的name
 * @param {*} callback 点击事件的回调函数
 * @param {*} hasHover 是否需要悬浮弹窗
 * @param {*} hasSelected 是否是需要地块选中效果
 * @param {*} customPolygonMouseenter 鼠标悬浮效果
 */
TalksMap.prototype.land = function (
  data,
  dataName,
  callback,
  hasHover = true,
  hasSelected = true,
  customPolygonMouseenter
) {
  let polygon, lng, lat;
  this.polygonLayerLand.clear();
  // if (data.length == 0) {
  //   vm.$message({
  //     message: "暂无数据",
  //     type: "warning",
  //   });
  //   return;
  // }
  if (data.length > 0) {
    let temp = JSON.parse(data[0].centroid);
    lng = temp.coordinates[0];
    lat = temp.coordinates[1];
    let Coordinate = {
      x: lng,
      y: lat,
    };
    this.map.setCenter(Coordinate);
  }
  // this.map.setZoom(17);
  data.forEach((item) => {
    if (typeof item[dataName] == "string") {
      item[dataName] = JSON.parse(item[dataName]);
    }
    if (!item[dataName] || !item[dataName].coordinates) {
      return;
    }
    if (!item.isSelected) {
      item.isSelected = 0;
    }
    if (!item.colour) {
      item.colour = "#fff";
    }
    polygon = new maptalks.Polygon(
      item[dataName].coordinates,
      {
        visible: true,
        editable: true,
        cursor: "指针",
        shadowBlur: 0,
        shadowColor: "black",
        draggable: false,
        dragShadow: false, // display a shadow during dragging
        drawOnAxis: null, // force dragging stick on a axis, can be: x, y
        symbol: {
          polygonFill: item.colour, // 图形覆盖颜色
          polygonOpacity: 0.5, // 图形覆盖区域透明度
          lineColor: item.colour, // 线条颜色
          lineWidth: 2, // 线条宽度
        },
      },
      {
        properties: {
          landStatus: item.landStatus,
        },
      }
    );
    polygon.val = item;
    polygon.flag = item.isSelected;
    if (hasSelected) {
      if (item.isSelected == 1) {
        polygon.updateSymbol({
          lineColor: "#fff",
          lineDasharray: [5, 5],
          polygonOpacity: 1,
        });
      }
    }
    if (callback) {
      polygon.on("click", callback);
    }
    if (hasHover) {
      polygon
        .on(
          "mouseenter",
          customPolygonMouseenter ? customPolygonMouseenter : polygonMouseenter
        )
        .on("mouseout", function (e) {
          e.target.closeInfoWindow();
        });
    }
    function polygonMouseenter(e) {
      var options = {};
      vm.$http.work.getLandDetail({ id: e.target.val.id }).then((res) => {
        let detail = res.data;
        options = {
          single: true,
          title: false,
          autoOpenOn: null, //单击地图时不打开窗口，则设置为null
          content: `<div class="map-info-box">
            <div class="msg-header">
              <p class="title">地块信息</p>
            </div>
            <div class="msg-body">
              <ul class="list">
                <li class="item">土地归属：${detail.croplandVillGroupName}</li>
                <li class="item">地块编号：${detail.croplandId}</li>
                <li class="item">土地属性：${detail.croplandTypeName}</li>
                <li class="item">地块面积：${detail.croplandArea}亩</li>
                <li class="item">地块周长：${detail.croplandPerimeter}米</li>
                <li class="item">位置描述：${detail.address ? detail.address : ""
            }</li>
                <li class="item">经营权归属：${detail.croplandFranchisedTypeName
            }</li>
                <li class="item">经营主体：${detail.croplandProprietor}</li>
              </ul>
            </div>
          </div>`,
          autoPan: false, //弹窗边界不移动地图
          width: 300,
          custom: false,
        };
        e.target.setInfoWindow(options);
        e.target.openInfoWindow();
      });
    }
    polygon.addTo(this.polygonLayerLand);
  });
};
/**
 * @description: 添加Marker
 * @Author: yangsibo
 * @Date: 2022-06-07 19:17:45
 * @param {*} markPonit
 */
TalksMap.prototype.addMarker = function (markPonit) {
  let marker = new maptalks.Marker({ x: markPonit.longitude, y: markPonit.latitude }).addTo(this.picMarker);
  let Coordinate = {
    x: Number(markPonit.longitude),
    y: Number(markPonit.latitude),
  };
  this.map.setCenter(Coordinate);
  this.picMarker.bringToFront();
};
/**
 * @descripttion: 添加多个图片Marker
 * @Author: juanjuanhui
 * @Date: 2022-04-28 20:40:27
 */
TalksMap.prototype.addMultiMarker = function (
  markPonit,
  imgUrl = require("@/assets/icon_clock_no.png"),
  callback
) {
  for (var i = 0; i < markPonit.length; i++) {
    let marker = new maptalks.Marker(
      [Number(markPonit[i].longitude), Number(markPonit[i].latitude)],
      {
        symbol: [
          {
            markerFile: imgUrl,
            markerWidth: 41,
            markerHeight: 50,
            markerDx: 0,
            markerDy: 0,
            markerOpacity: 1,
            val: markPonit[i],
          },
        ],
      }
    ).addTo(this.picMarker);
    let Coordinate = {
      x: Number(markPonit[0].longitude),
      y: Number(markPonit[0].latitude),
    };
    console.log(Coordinate);
    this.map.setCenter(Coordinate);
    marker.on("click", callback);
    this.picMarker.bringToFront();
  }
};
//传入两个经纬度点得到车辆角度 设置车辆Marker角度
const getAngle = (startPoint, endPoint) => {
  if (!(startPoint && endPoint)) {
    return 0;
  }

  let dRotateAngle = Math.atan2(
    Math.abs(startPoint[0] - endPoint[0]),
    Math.abs(startPoint[1] - endPoint[1])
  );
  if (endPoint[0] >= startPoint[0]) {
    if (endPoint[1] >= startPoint[1]) {
    } else {
      dRotateAngle = Math.PI - dRotateAngle;
    }
  } else {
    if (endPoint[1] >= startPoint[1]) {
      dRotateAngle = 2 * Math.PI - dRotateAngle;
    } else {
      dRotateAngle = Math.PI + dRotateAngle;
    }
  }
  dRotateAngle = (dRotateAngle * 180) / Math.PI;
  return dRotateAngle;
};
export default TalksMap;
